import React from "react";
import { RadioContainer } from "../../commons";
import { Warning } from "../../../assets/images";
import {
  convertToISO,
  returnInputFieldLength,
} from "../../../utils/commonFunctions";

type AppProps = {
  cancelEWayBillComment: string;
  radioValue: string;
  data: any;
  eWayBillAt: string | null;
  setCancelEWayBillComment: (data: string) => void;
  setRadioValue: (data: string) => void;
  isEWayPresent: number;
  isEWayBillCancel?: boolean;
  handleCancelEWayBill: () => void;
};

export const CANCEL_EWAYBILL_OPTION = [
  { id: "Duplicate", name: "Duplicate" },
  { id: "Order Cancelled", name: "Order Cancelled" },
  { id: "Data Entry mistake", name: "Data Entry mistake" },
  { id: "Others", name: "Others" },
];

const EWayBillCancel = ({
  cancelEWayBillComment,
  data,
  radioValue,
  eWayBillAt,
  setCancelEWayBillComment,
  setRadioValue,
  isEWayPresent,
  isEWayBillCancel,
  handleCancelEWayBill,
}: AppProps) => {
  eWayBillAt = eWayBillAt ? convertToISO(eWayBillAt) : eWayBillAt;

  return (
    <>
      {isEWayBillCancel ? (
        <div className="e-way-action-box p-0" style={{ height: "fit-content" }}>
          <div className="sub-heading-e-invoice ml-0 p-3">
            E-Way Bill Actions
          </div>
          <hr className="m-0"></hr>
          <div className="p-2">
            <div className="sub-heading-e-invoice mb-3 ml-0 mt-2">
              CANCEL E-WAY BILL
            </div>
            <div className="mb-2">
              Your comment or reason for cancelling the E-Way bill
            </div>
            <div>
              <textarea
                className="form-control"
                disabled={
                  !!eWayBillAt &&
                  +new Date(eWayBillAt)?.getTime() + 86400000 < +new Date()
                }
                style={{ width: "100%" }}
                value={cancelEWayBillComment}
                placeholder="Add a comment..."
                onChange={(text: any) =>
                  setCancelEWayBillComment(text.target.value)
                }
                maxLength={50}
              />
            </div>
            <span className="input-length ml-1 mt-1">
              {returnInputFieldLength(cancelEWayBillComment?.length, 50)}
            </span>
            <div className="sub-heading-e-invoice mb-2 ml-0 mt-3">
              {isEWayPresent === 1
                ? "Select reason"
                : !!eWayBillAt &&
                  +new Date(eWayBillAt)?.getTime() + 86400000 < +new Date()
                ? null
                : "Reason To Cancel Your E-Way Bill (Mandatory)"}
            </div>
            <div className="mb-2">
              {
                CANCEL_EWAYBILL_OPTION?.find(
                  (item: any) => item?.id == data?.cancel_remark
                )?.name
              }
            </div>

            {(isEWayPresent === 1 || isEWayPresent === 3) &&
            (!!eWayBillAt
              ? !(+new Date(eWayBillAt)?.getTime() + 86400000 < +new Date())
              : true) ? (
              <RadioContainer
                optionsList={CANCEL_EWAYBILL_OPTION}
                handleSetRadioValue={(radio: string) => setRadioValue(radio)}
                radioValue={radioValue}
                alignment="vertical"
              />
            ) : null}
            <button
              className="btn btn-primary mt-3"
              disabled={cancelEWayBillComment?.length === 0}
              onClick={handleCancelEWayBill}
            >
              Cancel E-Way Bill
            </button>
            {isEWayPresent !== 2 ? (
              <div className="alerts d-flex align-items-center">
                <img
                  src={Warning}
                  style={{ width: "25px", height: "25px" }}
                  alt="warning"
                  className="mr-2"
                />
                <div style={{ color: "#be7e12" }}>
                  You can cancel an e-way bill within 24 hours of issuance.
                </div>
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default EWayBillCancel;
